<template>

  <modalo
    :title="templateapply.name"
    type="medium"
    @hideModal="hideModal()"
    :modaloWatch="() => templateapply">

    <form id="templateapply-form" v-on:submit.prevent="saveTemplateapply(templateapply)">
      <div class="form-group">
        <label>{{ $t('Name') }}</label>
        <input
          v-autofocus
          type="text"
          class="form-control"
          v-model="templateapply.name">
        <ValidateMessage :error="validateErrors['name']" />
      </div>

      <div class="mb-3">
        <h5>{{ $t('Application question') }}</h5>
      </div>

      <div class="list-form" v-sortable="{ handle: '.sortable-move', items: templateapply.application_questions}">
        
        <div
          class="card"
          v-for="(question, question_index) in templateapply.application_questions"
          :key="question_index">
          
          <div class="card-header">
            <div class="d-flex justify-content-between">
              <div class="mr-auto"><a href="javascript:void(0)" class="sortable-move"><i class="fas fa-arrows-alt" /></a></div>
              <div class="pr-3"><input type="checkbox" id="inlineFormCheck" v-model="question.required"> {{ $t('Required') }}</div>
              <div><a href="javascript:void(0)" @click="removeQuestion(question_index)">{{ $t('Remove') }}</a></div>
            </div>
          </div>

          <div class="card-body">
            <div class="form-group">
              <input type="text" class="form-control" :placeholder="$t('Question')" v-model="question.label">
              <ValidateMessage :error="validateErrors['application_questions.' +question_index+ '.label']" />
            </div>
            <div class="form-group">
              <select type="text" class="form-control" v-model="question.type">
                <option value="text">{{ $t('Short text') }}</option>
                <option value="textarea">{{ $t('Long text') }}</option>
                <option value="radio">{{ $t('List of options (Single choice)') }}</option>
                <option value="checkbox">{{ $t('List of options (Multiple choice)') }}</option>
                <option value="boolean">{{ $t('Yes or no') }}</option>
              </select>
              <ValidateMessage :error="validateErrors['application_questions.' +question_index+ '.type']" />
            </div>

            <div v-if="question.type === 'boolean'">
              <input type="checkbox" v-model="question.disqualify">
              {{ $t('Disqualify candidate if answer is "no"') }}
              <ValidateMessage :error="validateErrors['application_questions.' +question_index+ '.disqualify']" />
            </div>

            <div v-if="question.type === 'radio' || question.type === 'checkbox'">
              <ul
                class="form-items"
                v-sortable="{ handle: '.move', items: question.options}">
                <li
                  v-for="(option, option_index) in question.options">
                  <div><a href="javascript:void(0)" class="move text-secondary"><i class="fas fa-arrows-alt" /></a></div>
                  <div class="form-items-input">
                    <input 
                      type="text" 
                      :placeholder="$t('Alternative')" 
                      v-model="question.options[option_index]">
                    <ValidateMessage :error="validateErrors['application_questions.' + question_index + '.options.' + option_index]" />
                  </div>
                  <div><a href="javascript:void(0)" @click="removeOption(question, option_index)" class="text-secondary"><i class="fas fa-times" /></a></div>
                </li>
              </ul>
              <ValidateMessage :error="validateErrors['application_questions.' + question_index + '.options']" />
              <br>
              <a href="javascript:void(0)"  @click="addOption(question.options)">Adicionar opção</a>
            </div>

          </div>

        </div>

      </div>

      <div><a href="javascript:void(0)" @click="addQuestion()">{{ $t('Add question') }}</a></div>

      <ValidateMessage :error="validateErrors['questions']" />

    </form>

    <template slot="footer">
      <div :class="{'box-loading': loading}">
        <button
          type="submit"
          form="templateapply-form"
          class="btn btn-primary">{{ $t('Save') }}</button>
        <button
          type="button"
          class="btn btn-light"
          @click="hideModal()">{{ $t('Cancel') }}</button>
        <button
          v-if="templateapply._id"
          type="button"
          class="btn btn-danger"
          @click="deleteTemplateapply(templateapply._id)">{{ $t('Delete') }}</button>  
      </div>
    </template>

  </modalo>

</template>

<script>
import InputOnePhoto from '@/components/Fields/InputOnePhoto'

export default {
  name: 'TemplateapplyForm',
  components: {
    InputOnePhoto
  },
  props: [
    'initTemplateapply'
  ],
  data () {
    return {
      loading: false,
      templateapply: this.defaultValues(this.initTemplateapply),
      validateErrors: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    /*
    defaultValues
    */
    defaultValues (values) {
      return values._id
      ? this.$clone(values)
      : Object.assign({
        'application_questions': [{
          'label': '',
          'required': true,
          'type': 'text', // [radio, textarea, checkbox, text]
          'options': []
        }]
      }, values)
    },
    addQuestion () {
      this.templateapply.application_questions.push({
        'label': '',
        'required': false,
        'type': 'text', // [radio, textarea, checkbox, text]
        'options': []
      })
    },
    removeQuestion (index) {
      this.templateapply.application_questions.splice(index, 1)
    },
    addOption (question) {
      question.push(null)
    },
    removeOption (question, index) {
      question.options.splice(index, 1)
    },
    /* hideModal  */
    hideModal () {
      this.$emit('hideModal')
    },
    /*
    saveTemplateapply
    */
    saveTemplateapply (data) {
      if (data._id) this.updateTemplateapply(data)
      else this.createTemplateapply(data)
    },
    /*
    createTemplateapply
    */
    createTemplateapply (data) {
      this.loading = true

      this.$store
      .dispatch('createTemplateapply', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    updateTemplateapply
    */
    updateTemplateapply (data) {
      this.loading = true

      this.$store
      .dispatch('updateTemplateapply', data)
      .then((result) => {
        this.loading = false
        this.$emit('saved')
      })
      .catch((err) => {
        this.loading = false
        if (err.response.data.name === 'ValidationError') {
          this.validateErrors = err.response.data.errors
        }
      })
    },
    /*
    delete
    */
    deleteTemplateapply (id) {
      const deleteAction = () => {
        this.loading = true

        this.$store
        .dispatch('deleteTemplateapply', id)
        .then((result) => {
          this.loading = false
          this.$emit('saved')
        })
      }

      this.$store
      .dispatch('setAlertModal', {
        action: deleteAction
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Templateapply/TemplateapplyForm.vue